<template>

    <div class="">

        <AdminBlock>
            <div class="d-flex justify-content-between align-items-center">
                <span>
                    Movements showing for Collection Date: {{ formatDate(movement.collection_date) }}
                </span>
                <a :href="generateBackRoute()" class="btn btn-danger btn-sm" style="width: 130px;">
                    Back
                </a>
            </div>
        </AdminBlock>

        <h2>Drivers</h2>
        <div v-if="drivers.length === 0" class="alert alert-info">
            No drivers available with the required licence for this vehicle type.
        </div>
        <div v-else class="row">
            <div v-for="(driver, index) in drivers" :key="index" class="col-4">
                <AdminBlock :title="driver.name">
                    <template #options>
                        <button
                            class="btn btn-warning btn-sm"
                            @click="assignMovement(movement.id, driver.id)"
                        >
                            Assign
                        </button>
                    </template>
                    <template v-if="driverMovements[driver.id] && driverMovements[driver.id].length > 0">
                        <div v-for="(movement, index) in driverMovements[driver.id]" :key="movement.id">
                            <ul class="list-unstyled mb-0">
                                <FloatingMovement
                                    v-model="localMovement"
                                    :last-item="index === driverMovements[driver.id].length - 1"
                                    :enable-movement-modal="false"
                                />
                            </ul>
                        </div>
                    </template>
                    <template v-else>
                        <p class="mb-0">This Driver has no assigned movements for this date</p>
                    </template>
                </AdminBlock>
            </div>
        </div>

        <template v-if="subcons.length > 0" >
            <h2 class="mt-4">Sub Contractors</h2>
            <div class="row">
                <div v-for="(subcon, index) in subcons" :key="index" class="col-4">
                    <AdminBlock :title="subcon.name">
                        <template #options>
                            <button
                                class="btn btn-warning btn-sm"
                                @click="assignMovement(movement.id, subcon.id)"
                            >
                                Assign
                            </button>
                        </template>
                        <template v-if="subconMovements[subcon.id] && subconMovements[subcon.id].length > 0">
                            <div v-for="(loopMovement, index) in subconMovements[subcon.id]" :key="loopMovement.id">
                                <ul class="list-unstyled mb-0">
                                    <FloatingMovement
                                        :movement="loopMovement"
                                        :last-item="index === subconMovements[subcon.id].length - 1"
                                        :enable-movement-modal="false"
                                    />
                                </ul>
                            </div>
                        </template>
                        <template v-else>
                            <p class="mb-0">This Driver has no assigned movements for this date</p>
                        </template>
                    </AdminBlock>
                </div>
            </div>
        </template>

        <template v-else-if="drivers.length > 0">
            <h2 class="mt-4">Sub Contractors</h2>
            <div class="alert alert-info">
                No sub contractors available with the required licence for this vehicle type.
            </div>
        </template>
    </div>

</template>

<script setup>

import axios from 'axios';
import { ref, onMounted } from 'vue';
import { errorAlert, successAlert } from "@/utils";
import AdminBlock from "@/components/movements/components/AdminBlock.vue";
import FloatingMovement from "@/components/movements/jobs/planner/FloatingMovement.vue";
import { useMovementFormatting } from '@/composables/useMovementFormatting';

const { formatDate } = useMovementFormatting();


const { movement } = defineProps({
    movement: {
        type: Object,
        required: true
    },
});

const localMovement = ref(movement);

const emit = defineEmits(['expense-created']);

const drivers = ref([]);
const driverMovements = ref({});

const subcons = ref([]);
const subconMovements = ref({});

onMounted(() => {

    axios.get(route('api.movements.movements.fetch-assign', {movement: movement.id}))
        .then((response) => {
            drivers.value = response.data.drivers;
            driverMovements.value = response.data.driver_movements;
            subcons.value = response.data.subcons;
            subconMovements.value = response.data.subcon_movements;
        })
        .catch((error) => {
            errorAlert(error, "Error Fetching Drivers");
        });

});

const assignMovement = (movementId, driverId) => {
    axios.post(route('api.movements.movements.assign', {movement: movementId, driver: driverId}))
        .then((response) => {
            const updatedMovement = response.data.movement;

            // Determine if this driver is a subcontractor by checking if the driver has an agency_id
            const assignedDriver = drivers.value.find(d => d.id === driverId) || subcons.value.find(d => d.id === driverId);
            const isSubcontractor = assignedDriver && assignedDriver.agency_id !== null;
            const selectedBucket = isSubcontractor ? subconMovements : driverMovements;

            // Add the movement to the driver's list
            const driverHasMovements = selectedBucket.value[updatedMovement.driver_id] || [];
            if (driverHasMovements.length > 0) {
                selectedBucket.value[updatedMovement.driver_id].push(updatedMovement);
            } else {
                selectedBucket.value = {
                    ...selectedBucket.value,
                    [updatedMovement.driver_id]: [ updatedMovement ]
                }
            }

            successAlert(`Movement assigned to ${updatedMovement.driver.name}`, "Movement Assigned", 2000, true)
            .then(() => {
                window.location.href = route('movements.movements.show', { movement: updatedMovement.id });
            });
        })
        .catch((error) => {
            console.log(error);
            errorAlert(error, "Error Assigning Movement to Driver");
        });
}

const generateBackRoute = () => {
    return route('movements.movements.show', { movement: movement });
}

</script>
